import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";
import { ChartData } from "./types";
import { poChartAltSeriesColors } from "../../lib/poTheme";

interface DataBarChartProps {
  data: ChartData;
}

const COLORS = poChartAltSeriesColors;

export default function DataBarChart({ data }: DataBarChartProps) {
  const xKey = data.xKey ?? data.columns[0];
  const yKeys =
    data.yKeys && data.yKeys.length > 0
      ? data.yKeys
      : data.columns.filter((c) => c !== xKey);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data.rows as Record<string, unknown>[]}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} />
        <YAxis />
        <Tooltip />
        <Legend />
        {yKeys.map((key, i) => (
          <Bar key={key} dataKey={key} fill={COLORS[i % COLORS.length]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
